import { graphql } from '@apollo/react-hoc';
import { gql } from 'graphql-tag';
import qs from 'qs';

export const query = gql`
  query GetAccounts($input: GetAccountsInput!) {
    getAccounts(input: $input) {
      count
      counts {
        live
        active
        inactive
      }
      results {
        id
        legal_name
        business_dba
        logo
        primary_contact
        email
        title
        country_code
        calling_code
        phone
        mailing {
          name
          address_line_1
          address_line_2
          city
          state
          zipcode
        }
        track {
          name
          address_line_1
          address_line_2
          city
          state
          zipcode
        }
        shipping {
          name
          address_line_1
          address_line_2
          city
          state
          zipcode
        }
        open_credits {
          credit_total
          num_credits
        }
        members {
          id
          name
          email
          cellphone
        }
        track_ids
        series_ids
        stripe_account_id
        stripe_url
        events_count
        inactive
      }
    }
  }
`;

export default graphql(query, {
  options: (props) => {
    const search = qs.parse(props?.location?.search, {
      ignoreQueryPrefix: true,
    });
    const input = { ...search };
    if (input.includeInactive) {
      input.includeInactive = input.includeInactive === 'true';
    }
    return {
      variables: { input },
    };
  },
});
